import Vue from 'vue'
import VueI18n from 'vue-i18n'
import spa from '@/lang/spa.json'
import eng from '@/lang/eng.json'

Vue.use(VueI18n)

export const idiomasApp = ['spa','eng']

export default new VueI18n({
  locale: idiomasApp[0],
  fallbackLocale: idiomasApp[0],
  messages: {
    spa,
    eng
  }
})


// WEBPACK FOOTER //
// ./src/plugins/vue-i18n.js